var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M11.001 0.499023C11.2771 0.499023 11.501 0.722881 11.501 0.999023V3.35631C11.501 3.63245 11.2771 3.85631 11.001 3.85631C10.7248 3.85631 10.501 3.63245 10.501 3.35631V0.999023C10.501 0.722881 10.7248 0.499023 11.001 0.499023Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51196 11.0001C6.51196 8.52122 8.52146 6.51172 11.0003 6.51172C13.4791 6.51172 15.4886 8.52122 15.4886 11.0001C15.4886 13.4789 13.4791 15.4884 11.0003 15.4884C8.52146 15.4884 6.51196 13.4789 6.51196 11.0001ZM11.0003 7.51172C9.07375 7.51172 7.51196 9.0735 7.51196 11.0001C7.51196 12.9266 9.07375 14.4884 11.0003 14.4884C12.9269 14.4884 14.4886 12.9266 14.4886 11.0001C14.4886 9.0735 12.9269 7.51172 11.0003 7.51172Z",
    fill: "#1D1D46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M4.28226 3.57418C4.087 3.37892 3.77042 3.37892 3.57516 3.57418C3.3799 3.76944 3.3799 4.08603 3.57516 4.28129L5.24193 5.94806C5.43719 6.14332 5.75377 6.14332 5.94903 5.94806C6.1443 5.75279 6.1443 5.43621 5.94903 5.24095L4.28226 3.57418Z",
    fill: "#1D1D46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M0.5 11.001C0.5 10.7248 0.723858 10.501 1 10.501H3.35729C3.63343 10.501 3.85729 10.7248 3.85729 11.001C3.85729 11.2771 3.63343 11.501 3.35729 11.501H1C0.723858 11.501 0.5 11.2771 0.5 11.001Z",
    fill: "#1D1D46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M5.94903 16.7579C6.1443 16.5626 6.1443 16.246 5.94903 16.0507C5.75377 15.8555 5.43719 15.8555 5.24193 16.0507L3.57516 17.7175C3.3799 17.9128 3.3799 18.2294 3.57516 18.4246C3.77042 18.6199 4.087 18.6199 4.28226 18.4246L5.94903 16.7579Z",
    fill: "#1D1D46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M11.001 18.1445C11.2771 18.1445 11.501 18.3684 11.501 18.6445V21.0018C11.501 21.278 11.2771 21.5018 11.001 21.5018C10.7248 21.5018 10.501 21.278 10.501 21.0018V18.6445C10.501 18.3684 10.7248 18.1445 11.001 18.1445Z",
    fill: "#1D1D46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M16.7597 16.0507C16.5644 15.8555 16.2478 15.8555 16.0526 16.0507C15.8573 16.246 15.8573 16.5626 16.0526 16.7579L17.7193 18.4246C17.9146 18.6199 18.2312 18.6199 18.4265 18.4246C18.6217 18.2294 18.6217 17.9128 18.4265 17.7175L16.7597 16.0507Z",
    fill: "#1D1D46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M18.1433 11.001C18.1433 10.7248 18.3672 10.501 18.6433 10.501H21.0006C21.2767 10.501 21.5006 10.7248 21.5006 11.001C21.5006 11.2771 21.2767 11.501 21.0006 11.501H18.6433C18.3672 11.501 18.1433 11.2771 18.1433 11.001Z",
    fill: "#1D1D46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M18.4265 4.28129C18.6217 4.08603 18.6217 3.76944 18.4265 3.57418C18.2312 3.37892 17.9146 3.37892 17.7193 3.57418L16.0526 5.24095C15.8573 5.43621 15.8573 5.75279 16.0526 5.94806C16.2478 6.14332 16.5644 6.14332 16.7597 5.94806L18.4265 4.28129Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.990e9a29e4524a0333486c84760ade68.svg";
export { ForwardRef as ReactComponent };